export default __webpack_public_path__ + "static/media/hoitokeskustelu-darkblue.835b8242.svg";